module.exports = __webpack_public_path__ + "static/media/sportssquared.38d14f45.png";